import { render } from "./recentnfts.vue?vue&type=template&id=20e6f366"
const script = {}

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__